module.exports = __webpack_public_path__ + "static/media/background_btn_2@2x.148bdaa5.png";